import { Weather, Forecast } from './../classes/weather';
import { Component, Input, OnInit, ViewChild, OnDestroy, AfterViewInit, OnChanges, SimpleChanges, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label, BaseChartDirective } from 'ng2-charts';
import { WeatherData } from '../classes/weather-data';
import { Observable, interval, Subscription } from 'rxjs';
import { preserveWhitespacesDefault } from '@angular/compiler';
import { BrowserTransferStateModule } from '@angular/platform-browser';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.css']
})

export class LineChartComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {



  @Input() forecast: Forecast[];

  @ViewChild('baseChart') chart: BaseChartDirective;

  isBrowser = false;

  private updateSubscription: Subscription;
  public lineChartData: ChartDataSets[];
  public lineChartLabels: Label[] = [];
  private precipitionSum: number = 0;
  lineChartOptions = {
    tooltips: {
      titleFontSize: 10,
      bodyFontSize: 10,
      position: 'average' ,
      xPadding: 15,
      ypadding: 15,
      caretPadding: 5,
      enabled: true,
      custom(tooltipModel) {
        if (!tooltipModel) { return; }
        // disable displaying the color box;
        tooltipModel.displayColors = false;
      },
      callbacks: {
        title(tooltipItem, data) {
          if(data.labels[tooltipItem[0].index] !== undefined)
            {
            return data.labels[tooltipItem[0].index];
            }
        },
        label(tooltipItem, data) {

        },
        afterLabel(tooltipItem, data) {
          if(data.datasets[0].data[tooltipItem.index] !== undefined && 
            data.datasets[1].data[tooltipItem.index] !== undefined &&
            data.datasets[2].data[tooltipItem.index] !== undefined &&
            data.datasets[3].data[tooltipItem.index] !== undefined 
            )
            {
          var value = "Lämpötila: " + data.datasets[0].data[tooltipItem.index] + '\xB0C\n';
           value += "Tuuli: " + data.datasets[3].data[tooltipItem.index] + 'm/s\n';
           value += "Sade ("+ data.labels[tooltipItem.index] +"): "+ data.datasets[1].data[tooltipItem.index] + 'mm\n';
          value += "Sade ("+data.labels[0]+"-"+data.labels[tooltipItem.index] +"): " + data.datasets[2].data[tooltipItem.index] + 'mm';
          return value;
            }
        }
      }

    },
    hover: {mode: 'nearest'},
    pointDotRadius : 3,
    responsive: true,
    scales: {
      yAxes: [{
        id: 'A',
        gridLines: {
          display: false,
          color:  'rgba(220,220,220, 0.3)',
          drawBorder: false,
          zeroLineColor: 'rgba(0, 0, 0, 0.5)'
        },
        ticks: {
          fontColor: 'white',
          fontfamily: 'Arial',
          fontStyle: 'bold',
          precision: 0,
          maxTicksLimit: 7,
           callback(value, index, values) {
            return value + '\xB0C'; }
        }
      },

      {
        id: 'B',
        position: 'right',
        gridLines: {
          display: true,
          drawBorder: false,
          // zeroLineColor: '',
        },
        ticks: {
          fontColor:  	'rgba(255,255, 255, 0.3)',
          fontfamily: 'Arial',
          fontStyle: 'bold',
          fontSize: 10,
          beginAtZero: true,
          suggestedMax: 5,
          precision: 2,
          stepSize: 1.0,
          maxTicksLimit: 7,
        callback(value, index, values) {
          return value + 'mm'; }



        },
      },
        {
          id: 'C',
          position: 'right',
          gridLines: {
            display: false,
            drawBorder: false,
            // zeroLineColor: '',
          },
          ticks: {
            fontColor:  	'rgba(255,255, 255, 0.6)',
            fontfamily: 'Arial',
            fontStyle: 'bold',
            fontSize: 2,
            
            beginAtZero: false,
            suggestedMax: 1,
            precision: 1,
            stepSize: 1.0,
            maxTicksLimit: 1,
            callback(value, index, values) {
              // Don't show this yaxis
            }
  
          }

      }


    ],
      xAxes: [{
        id: 'timeaxis',
        position: 'bottom',
        gridLines: {
          display: false,
        },

        ticks: {
          fontColor: 'white',
          fontfamily: 'Arial',
          fontStyle: 'bold',

        }
      },{
        id: 'windaxis',
        position: 'top',
        gridLines: {
          display: false,
        },

        ticks: {
          fontColor: 'white',
          fontfamily: 'Arial',
          fontSize: 8,
          fontStyle: 'bold',
          /*
          maxRotation: 0,
          minRotation: 0,*/
          callback: function(value, index, ticks){
            if (this.chart !== undefined && this.chart.data.datasets[3].data[index] !== undefined) {
            return this.chart.data.datasets[3].data[index]+" m/s"; // override top xaxis label that it shows windspeed instead of hours
            }
        },

        }
      },
      
    ]

  
    },

    /*elements: {
      point: {
         radius: 0
      }

    },*/


  };

  lineChartColors: Color[] = [
    {
      borderColor: 'white',

    },
  ];

  lineChartLegend = false;
  lineChartPlugins = [];
  lineChartType = 'line';


  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (!this.isBrowser) {
      return; // skip chart setup on server
    }

    this.updateChartData();
        // 21 minutes == 1260000
    // 15 min = 900000
    // 10 mmin == 600000
    // 6 min =        360000
    this.updateSubscription = interval(900000).subscribe((val) => { this.updateChart(); });


    const chartRefreshPromise = new Promise<string>((resolve, reject) => {
      // a resolved promise after certain time
      setTimeout(() => {
        this.chart.update();
        resolve('chart refreshed');
      }, 1000); // resolves after 1s
    });

  }


  ngAfterViewInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.forecast) {
      this.updateChartData();
      if (this.chart) { this.chart.update(0); }
    }
  }

  ngOnDestroy(): void {
    if (this.updateSubscription) {
      this.updateSubscription.unsubscribe();
    }
  }


  updateChartData() {
    this.precipitionSum = 0; // reset cumulative sum before recomputing
    this.lineChartData = [
      {
        data: this.forecast.filter(x => {

                  if (!isNaN(parseFloat(x.Temperature))) {
                    const currentDate = new Date();
                    const diffMs = (x.Time.getTime() - currentDate.getTime()); // milliseconds
                    let diffMins = Math.round(diffMs / 60000); // minutes
                    let diffHrs = Math.round(diffMins / 60); // hours

                    if (diffHrs <=0) {
                        return; }

                    return x;
                  }

                  }).map(x => parseFloat(x.Temperature)),
        fill: false,
        yAxisID: 'A',
        order: 1,
        pointHitRadius: 20,
        pointStyle: this.forecast.filter(x => {

          
            const currentDate = new Date();
            const diffMs = (x.Time.getTime() - currentDate.getTime()); // milliseconds
            let diffMins = Math.round(diffMs / 60000); // minutes
            let diffHrs = Math.round(diffMins / 60); // hours
            // console.log('diffHrs:'+diffHrs);
            if (diffHrs <= 0) {
                return; }

            return x;

          
         

          }).map(x => {
          if (!this.isBrowser) { return null; }
          const image = new Image(25, 25);

          if (x.Time.getHours() % 3 === 0) {
            image.src = x.WeatherSymbolUrl;

            if (x.WeatherSymbolUrl.includes('yrno')) {
              image.height = 27;
              image.width = 27;
            } else {
              if (x.WeatherSymbolUrl.includes('png')) {
                image.height = 25;
                image.width = 25;
              } else if (x.WeatherSymbolUrl.includes('svg')) {
                image.height = 37;
                image.width = 37;
              }
            }
          }

          return image;

        }).filter(i => i !== null),
        pointRadius: 13,
      },
      {
        data: this.forecast.filter(x => !isNaN(parseFloat(x.Precipitation))).map(x => parseFloat(x.Precipitation)),
        fill: false,
        yAxisID: 'B',
        order: 2,
        pointHitRadius: 10,
        type: 'bar',
      },
      {
        data: this.forecast.filter(x => !isNaN(parseFloat(x.Precipitation))).map(x => {
          // Kokonais sadesumma
          this.precipitionSum +=parseFloat(x.Precipitation);;
          return Math.round(this.precipitionSum * 100) / 100;
          
        }),
        fill: false,
        yAxisID: 'B',
        order: 3,
        pointHitRadius: 10,
        type: 'line',
        pointRadius: 0,
        backgroundColor:'rgba(255,255, 255, 0.3)',
        borderColor: 'rgba(255,255, 255, 0.2)',
        borderWidth: 2
      },
      {
        data: this.forecast.filter(x => !isNaN(parseFloat(x.WindSpeed))).map(x => parseFloat(x.WindSpeed)),
        fill: false,
        yAxisID: 'C',
        order: 4,
        pointHitRadius: 0,
        type: 'line',
        showLine: false,
        pointRadius: 0,

      },
    ];


    this.lineChartLabels = this.forecast
      .filter(x => {

        if (!isNaN(parseFloat(x.Temperature))) {
          const currentDate = new Date();
          const diffMs = (x.Time.getTime() - currentDate.getTime()); // milliseconds
          let diffMins = Math.round(diffMs / 60000); // minutes
          let diffHrs = Math.round(diffMins / 60); // hours

          if (diffHrs <=0) {
              return; }


          return x;
        }

        })
      .map(x => {
        const returnstring = x.Time.toLocaleString('fi', { weekday: 'short' }) +
          ' ' +
          x.Time.toLocaleString('fi', { hour: '2-digit', minute: '2-digit' });

      
        return returnstring;
      });



  }

  updateChart() {
    this.updateChartData();
    if (this.chart !== undefined) {
      this.chart.update(0);
    }
  }


}
